<div class="dialog">
    <div class="content">
        <div class="head container-fluid mr-0 ml-0 pl-0 row">
            <h6 class="mb-0 col-md-11">Machine details</h6>
            <img (click)="close()" class="text-right pointer" src="assets/svg/close-white.svg" alt="">
        </div>
        <div class="body row mr-0 ml-0 pl-0">
            <div class="col-md-3 pl-0 pr-5">
                <div class="sub-head row mr-0 ml-0 pl-0">
                    <img class="col-md-3 pr-2" src="./assets/images/sheet_metal.png" alt="">
                    <p class="mb-0 col-md-4 pl-0 tech-name"> {{selectedManufacturingTechnology?.name}}</p>
                </div>
                <img *ngIf="selectedManufacturingTechnology.name == 'Sheet Metal Manufacturing'" class="machine-img mt-3 mb-3" src="assets/svg/Sheet metal.svg" alt="">
                <img *ngIf="selectedManufacturingTechnology.name == '3D Printing'" class="machine-img mt-3 mb-3" src="assets/svg/3D Print.svg" alt="">
                <img *ngIf="selectedManufacturingTechnology.name == 'Casting/Forging'" class="machine-img mt-3 mb-3" src="assets/svg/Metal Casting.svg" alt="">
                <img *ngIf="selectedManufacturingTechnology.name == 'CNC Machining'" class="machine-img mt-3 mb-3" src="assets/svg/CNC Machine.svg" alt="">
                <img *ngIf="selectedManufacturingTechnology.name == 'Injection Molding'" class="machine-img mt-3 mb-3" src="assets/svg/Injection Moding.svg" alt="">
                <img *ngIf="selectedManufacturingTechnology.name == 'Vacuum Casting'" class="machine-img mt-3 mb-3" src="assets/svg/Vacuum Casting 2.svg" alt="">

                <button (click)="submitMachineDetails()" class="orange mt-3 mb-3 button-font">Save</button>
                <button (click)="close()" class="white button-font">Cancel</button>
            </div>
            <div class="col-md-9 pl-5 pr-0 custom-form">
                <form [formGroup]="machineForm" (ngSubmit)="submitMachineDetails()">
                    <div class="row container-fluid mr-0 ml-0 pl-0 pr-0 ">
                        <div class="col-md-6 pl-0">
                            <label><span style="color: #ff0000;">*</span> Machine Type</label>
                            <span class="form-error-text onboarding-span" *ngIf="machineForm.get('machine_name').invalid && machineForm.get('machine_name').touched">* Required</span>
                            <div class="auto-complete">
                                <ng-autocomplete [data]="machines" [searchKeyword]="keywordMachines" (inputChanged)='onChangeMachineSearch($event)' (selected)='onMachineSelectSetSpecs($event)' [itemTemplate]="itemMachineTemplate" formControlName="machine_name">
                                </ng-autocomplete>
                            </div>

                            <ng-template #itemMachineTemplate let-item>
                                <a [innerHTML]="item.display_name">{{item.display_name | titlecase}}</a>
                            </ng-template>
                        </div>
                        <div class="col-md-6 pr-0">
                            <label><span style="color: #ff0000;">*</span> Brand Name</label>
                            <span class="form-error-text onboarding-span" *ngIf="machineForm.get('brand_name').invalid && machineForm.get('brand_name').touched">*Brand is required</span>
                            <!-- <input type="text" formControlName="brand_name" [ngClass]="{'is-invalid':machineForm.get('brand_name').invalid && machineForm.get('brand_name').touched}"> -->
                            <ng-autocomplete [data]="brands" [searchKeyword]="keywordBrand" (inputChanged)='onChangeBrandSearch($event)' [itemTemplate]="itemTemplateBrand" formControlName="brand_name">
                            </ng-autocomplete>
                            <ng-template #itemTemplateBrand let-item>
                                <a [innerHTML]="item.display_name">{{item.display_name}}</a>
                            </ng-template>
                        </div>
                    </div>
                    <div class="row mt-3 container-fluid mr-0 ml-0 pl-0 pr-0 ">
                        <div class="col-md-6 pl-0">
                            <label><span style="color: #ff0000;">*</span> Model Number</label>
                            <span class="form-error-text onboarding-span" *ngIf="machineForm.get('model_number').invalid && machineForm.get('model_number').touched">*Model required</span>
                            <input type="text" formControlName="model_number" [ngClass]="{'is-invalid': machineForm.get('model_number').invalid && machineForm.get('model_number').touched}">
                        </div>
                        <div class="col-md-6 pr-0">
                            <label><span style="color: #ff0000;">*</span> No. of Machines</label>
                            <span class="form-error-text onboarding-span" *ngIf="machineForm.get('number_of_machines').invalid && machineForm.get('number_of_machines').touched">* Required</span>
                            <input type="text" formControlName="number_of_machines" [ngClass]="{'is-invalid': machineForm.get('number_of_machines').invalid && machineForm.get('number_of_machines').touched}">
                            <small *ngIf="selectedMachine.display_name =='lasercutting'"><img src="assets/svg/Icon feather-info.svg" alt="">&nbsp;&nbsp;Total number of Laser machines</small>
                        </div>
                    </div>
                    <div class="container-fluid mr-0 ml-0 pl-0">
                        <div class="col-md-7 pl-0">
                            <label for=""><span style="color: #ff0000;">*</span> Monthly Spare Capacity</label>
                            <span class="form-error-text onboarding-span" *ngIf="machineForm.get('spare_capacity').invalid && machineForm.get('spare_capacity').touched">* Required</span>
                            <input type="text" formControlName="spare_capacity" class="monthly-spare" [ngClass]="{'is-invalid': machineForm.get('spare_capacity').invalid && machineForm.get('spare_capacity').touched}">
                            <span style="position: absolute; top: 40px; right: 30px; font-size: 16px;">%</span>
                            <span class=" form-error-text onboarding-span" *ngIf="machineForm.get('spare_capacity').invalid && machineForm.get('spare_capacity').touched">                                
                                    <div *ngIf="machineForm.get('spare_capacity').errors?.min" >Cannot be less than 0.
                                    </div>
                                    <div *ngIf="machineForm.get('spare_capacity').errors?.max" >Cannot be more than 100.
                                    </div>
                            </span>
                            <small><img src="assets/svg/Icon feather-info.svg" alt="">&nbsp;&nbsp;Average idle machine capacity per machine</small>
                        </div>
                    </div>
                    <hr>
                    <br>
                    <h6 *ngIf=" !['Lasercutting','lasercutting', 'Punching', 'Combi Machines', 'Bending', 'Panel Bending', 'Welding', 'Straightening machine', 'De-burring machine','bending','panel bending','combi machines','de-burring machine'].includes(selectedMachine.display_name)">Specification Details</h6>
                    <!--*********************** Laser-cutting***************************** -->
                    <div name="laser_cutting" *ngIf="selectedMachine.display_name =='lasercutting'">
                        <div class="container-fluid mr-0 ml-0 pl-0">
                            <h6>Laser Type</h6>
                            <mat-radio-group formControlName="laser_type">
                                <mat-radio-button class="col-md-2 pl-0" color="warn" value="CO2"><span class="checkbox-label">CO<sub>2</sub></span></mat-radio-button>
                                <mat-radio-button class="col-md-2" color="warn" value="Fibre/Disc"><span class="checkbox-label">Solid State</span></mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class=" ml-0 mr-0 pl-0 row">
                            <div class="mr-1 col-md-4 pl-0">
                                <label for="">Laser Power</label>
                                <input type="text" formControlName="laser_power">
                            </div>
                            <div class="col-md-2">
                                <label for="">Unit</label>
                                <input type="text">
                            </div>
                        </div>
                        <h6 class="range mt-2">Max Sheet Thickness</h6>
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="pl-0 col-md-4">
                                <label>1.&nbsp;Mild Steel</label>
                                <input type="text" class="" formControlName="max_sheet_thickness_mild_steel">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" formControlName="max_sheet_thickness_mild_steel_unit">                                    
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                            <div class=" col-md-4">
                                <label>2.&nbsp;Stainless Steel</label>
                                <input type="text" formControlName="max_sheet_thickness_stainless_steel">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" name="max_sheet_thickness_stainless_steel_unit" id="max_sheet_thickness_stainless_steel_unit" formControlName="max_sheet_thickness_stainless_steel_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                        </div>
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="pl-0 col-md-4">
                                <label>3.&nbsp;Aluminium</label>
                                <input type="text" class="" formControlName="max_sheet_thickness_aluminium">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" name="" id="max_sheet_thickness_aluminium_unit" formControlName="max_sheet_thickness_aluminium_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                            <div class=" col-md-4">
                                <label>4.&nbsp;Copper</label>
                                <input type="text" formControlName="max_sheet_thickness_copper">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="max_sheet_thickness_copper_unit" formControlName="max_sheet_thickness_copper_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                        </div>
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="pl-0 col-md-4">
                                <label>5.&nbsp;Brass</label>
                                <input type="text" class="" formControlName="max_sheet_thickness_brass">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" name="" id="max_sheet_thickness_brass_unit" formControlName="max_sheet_thickness_brass_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                        </div>
                        <h6 class="range mt-2">Working Range</h6>
                        <div class=" ml-0 mt-2 mr-0 pl-0 row">
                            <div class="mr-1 col-md-3 pl-0">
                                <label for="">X</label>
                                <input type="text" formControlName="working_range_x">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="working_range_x_unit" formControlName="working_range_x_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                            <div class="col-md-3">
                                <label for="">Y</label>
                                <input type="text" formControlName="working_range_y">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" name="" id="working_range_y_unit" formControlName="working_range_y_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                        </div>
                        <br>
                        <hr>
                        <br>
                        <div class="row mr-0 ml-0 pl-0">
                            <div class="col-md-6 pl-0">
                                <div class="dropdown">
                                    <label>Cutting Gases</label>
                                    <select class="select arrow-img" id="cutting_gases" formControlName="cutting_gas_oxygen">
                                        <option value="">Select</option>
                                        <option value="Oxygen">Oxygen</option>
                                        <option value="Nitrogen">Nitrogen</option>
                                        <option value="compressed air"> Compressed Air</option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                <label for="">Marking Possible</label>
                                <div class="mt-2">
                                    <mat-radio-group formControlName="marking_possible">
                                        <mat-radio-button [value]="'true'" class="col-md-7" color="warn"><span class="checkbox-label">Yes</span></mat-radio-button>
                                        <mat-radio-button [value]="'false'" class="col-md-5" color="warn"><span class="checkbox-label">No</span></mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ***************************punching******************************** -->
                    <div *ngIf="selectedMachine.display_name =='Punching' || selectedMachine.display_name =='punching'" name="punching" class="">
                        <div class="row ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">Punch Force</label>
                                <input type="text" formControlName="punch_force">
                            </div>
                            <div class="col-md-5">
                                <label for="">Sheet Thickness(Max)</label>
                                <input type="text" formControlName="sheet_thickness">
                            </div>
                            <div class="dropdown col-md-2">
                                <label for="">Unit</label>
                                <select class="select arrow-img" id="sheet_thickness_unit" formControlName="sheet_thickness_unit">                                    
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>                                    
                                </select>
                            </div>
                        </div>
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">Tool Stations</label>
                                <input type="text" formControlName="tool_stations">
                            </div>
                            <div class="col-md-5">
                                <label for="">Tooling Diameter(Max)</label>
                                <input type="text" formControlName="tooling_diameter">
                            </div>
                            <div class="dropdown col-md-2">
                                <label for="">Unit</label>
                                <select class="select arrow-img" id="tooling_diameter_unit" formControlName="tooling_diameter_unit">                                    
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>                                    
                                </select>
                            </div>
                        </div>
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">No. of Indexing stations</label>
                                <input type="text" formControlName="no_of_indexing_stations">
                            </div>
                            <div class="col-md-5">
                                <label for="">Indexing diameter(Max)</label>
                                <input type="text" formControlName="indexing_diameter">
                            </div>
                            <div class="dropdown col-md-2">
                                <label for="">Unit</label>
                                <select class="select arrow-img" id="indexing_diameter_unit" formControlName="indexing_diameter_unit">                                    
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>                                    
                                </select>
                            </div>
                        </div>

                        <h6 class="range mt-4">Working Range</h6>
                        <div class=" ml-0 mt-2 mr-0 pl-0 row">
                            <div class="col-md-4 pl-0">
                                <label for="">X</label>
                                <input type="text" formControlName="working_range_x">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="working_range_x_unit" formControlName="working_range_x_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                            <div class="col-md-4">
                                <label for="">Y</label>
                                <input type="text" formControlName="working_range_y">
                            </div>
                            <div class="dropdown col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="working_range_y_unit" formControlName="working_range_y_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                        <br>
                        <hr>
                        <br>
                        <div class="dropdown row mr-0 ml-0 pl-0">
                            <label>Additional processes available</label>
                            <select class="select arrow-img" id="additional_process_available" formControlName="additional_process_available">
                                <option value="forming">Forming</option>
                            </select>
                        </div>
                        <div class=" ml-0 mt-3 mr-0 pl-0 row">
                            <div class="col-md-4 pl-0">
                                <label for="">Max Dimensions</label>
                                <input type="text" formControlName="forming_max_dimensions">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="forming_max_dimensions_unit" formControlName="forming_max_dimensions_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="">Max Height</label>
                                <input type="text" formControlName="forming_max_height">
                            </div>
                            <div class="dropdown col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="forming_max_height_unit" formControlName="forming_max_height_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                        <div class="ml-0 mr-0 pl-0 mt-3 row">
                            <div class="pl-0 col-md-4">
                                <label for="">Max Angle</label>
                                <input type="text" formControlName="forming_max_angle">
                            </div>
                            <div class="dropdown col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="forming_max_angle_unit" formControlName="forming_max_angle_unit">
                                    <option value="degree">degree</option>
                                    <option value="radian">radian</option>
                                    <option value="turn">turn</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- **************************combi-machines************************** -->
                    <div *ngIf="selectedMachine.display_name =='Combi Machines'">
                        <div class="container-fluid mr-0 ml-0 pl-0">
                            <h6>Laser Type</h6>
                            <mat-radio-group formControlName="laser_type">
                                <mat-radio-button class="col-md-2 pl-0" color="warn" value="CO2"><span class="checkbox-label">CO<sub>2</sub></span></mat-radio-button>
                                <mat-radio-button class="col-md-2" color="warn" value="Fibre/Disc"><span class="checkbox-label">Solid State</span></mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class=" ml-0 mt-3 mr-0 pl-0 row">
                            <div class="mr-1 col-md-4 pl-0">
                                <label for="">Laser Power</label>
                                <input type="text" formControlName="laser_power">
                            </div>
                            <div class="col-md-2">
                                <label for="">Unit</label>
                                <input type="text">
                            </div>
                        </div>
                        <h6 class="range mt-3">Max Sheet Thickness for Lasercutting:</h6>
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="pl-0 col-md-4">
                                <label>1.&nbsp;Mild Steel</label>
                                <input type="text" class="" formControlName="max_sheet_thickness_mild_steel">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" formControlName="max_sheet_thickness_mild_steel_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                            <div class=" col-md-4">
                                <label>2.&nbsp;Stainless Steel</label>
                                <input type="text" formControlName="max_sheet_thickness_stainless_steel">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" name="max_sheet_thickness_stainless_steel_unit" id="max_sheet_thickness_stainless_steel_unit" formControlName="max_sheet_thickness_stainless_steel_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                        </div>
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="pl-0 col-md-4">
                                <label>3.&nbsp;Aluminium</label>
                                <input type="text" class="" formControlName="max_sheet_thickness_aluminium">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" name="" id="max_sheet_thickness_aluminium_unit" formControlName="max_sheet_thickness_aluminium_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                            <div class=" col-md-4">
                                <label>4.&nbsp;Copper</label>
                                <input type="text" formControlName="max_sheet_thickness_copper">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="max_sheet_thickness_copper_unit" formControlName="max_sheet_thickness_copper_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                        </div>
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="pl-0 col-md-4">
                                <label>5.&nbsp;Brass</label>
                                <input type="text" class="" formControlName="max_sheet_thickness_brass">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" name="" id="max_sheet_thickness_brass_unit" formControlName="max_sheet_thickness_brass_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                        </div>
                        <h6 class="range mt-3">Max sheet thickness for Punching:</h6>
                        <div class=" ml-0 mt-3 mr-0 pl-0 row">
                            <div class="mr-1 col-md-6 pl-0">
                                <label for="">Indexing diameter  (Max)</label>
                                <input type="text" formControlName="max_sheet_thickness_punching">
                            </div>
                            <div class="col-md-2">
                                <label class="mt-1" for="max_sheet_thickness_punching_unit">Unit</label>
                                <select class="select arrow-img" id="max_sheet_thickness_punching_unit" formControlName="max_sheet_thickness_punching_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>

                            </div>
                        </div>
                        <h6 class="range mt-3">Working Range</h6>
                        <div class=" ml-0 mt-2 mr-0 pl-0 row">
                            <div class="mr-1 col-md-3 pl-0">
                                <label for="">X</label>
                                <input type="text" formControlName="working_range_x">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" id="working_range_x_unit" formControlName="working_range_x_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                            <div class="col-md-3">
                                <label for="">Y</label>
                                <input type="text" formControlName="working_range_y">
                            </div>
                            <div class="dropdown  col-md-2">
                                <label>Unit</label>
                                <select class="select arrow-img" name="" id="working_range_y_unit" formControlName="working_range_y_unit">
                                <option value="mm">mm</option>
                                <option value="inch">inch</option>
                            </select>
                            </div>
                        </div>
                        <br>
                        <hr>
                        <br>
                        <div class="row mr-0 ml-0 pl-0">
                            <div class="col-md-6 pl-0">
                                <div class="dropdown">
                                    <label>Cutting Gases</label>
                                    <select class="select arrow-img" id="cutting_gases">
                                    <option value="">Select</option>
                                    <option value="mm">Oxygen</option>
                                    <option value="inch">Nitrogen</option>
                                    <option value="compressed air"> Compressed Air</option>
                                </select>
                                </div>
                            </div>
                            <div>
                                <label for="">Marking Possible</label>
                                <div class="mt-2">
                                    <mat-radio-group formControlName="marking_possible">
                                        <mat-radio-button [value]="'true'" class="col-md-7" color="warn"><span class="checkbox-label">Yes</span></mat-radio-button>
                                        <mat-radio-button [value]="'false'" class="col-md-5" color="warn"><span class="checkbox-label">No</span></mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                        <br>
                        <hr>
                        <br>


                    </div>
                    <!-- *******************************Bending****************************** -->
                    <div *ngIf="selectedMachine.display_name =='Bending'" name="bending">
                        <h6 class="range">Bending Tonnage</h6>
                        <div class="row mt-2 mr-0 ml-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label>Bending Length (Max)</label>
                                <input type="text" formControlName="bending_length">
                            </div>
                            <div class="dropdown ">
                                <label>Unit</label>
                                <select class="select arrow-img" id="bending_length_unit" formControlName="bending_length_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-2 mr-0 ml-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label>Free Passage Between Pillars</label>
                                <input type="text" formControlName="free_passage_between_pillars">
                            </div>
                            <div class="dropdown ">
                                <label>Unit</label>
                                <select class="select arrow-img" id="free_passage_between_pillars_unit" formControlName="free_passage_between_pillars_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-2 mr-0 ml-0 pl-0">
                            <div class="dropdown ">
                                <label>Bending Aids</label>
                                <select class="select arrow-img" id="bending_aids" formControlName="bending_aids">
                                    <option value="">Select</option>
                                    <option value="hydraulic">Hydraulic</option>
                                    <option value="pneumatic">Pneumatic</option>
                                </select>
                            </div>
                            <div class="ml-5">
                                <label for="">Support Brackets</label>
                                <br>
                                <mat-radio-group class="mt-4" formControlName="support_brackets">
                                    <mat-radio-button class=" pl-0 col-md-5" color="warn" [value]="true"><span class="checkbox-label ">Yes</span></mat-radio-button>
                                    <mat-radio-button class="col-md-5" color="warn" [value]="false"><span class="checkbox-label">No</span></mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                    <!-- ****************************panel-bending************************** -->
                    <div *ngIf="selectedMachine.display_name =='panel bending'" class="row mr-0 ml-0 pl-0">
                        <div class="col-md-12 pl-0">
                            <label for="">Total Number of Panel Benders</label>
                            <input type="text" formControlName="total_number_of_panel_benders" maxlength="6">
                        </div>
                    </div>
                    <!-- *******************************Welding****************************** -->
                    <div *ngIf="selectedMachine.display_name =='Welding'" class="container-fluid mr-0 ml-0 pl-0">
                        <div class="row mr-0 ml-0 pl-0">
                            <label for="">Welding Type</label>
                            <input type="text" formControlName="welding_type">
                        </div>
                        <div class="row mt-3 ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">Seam Length (Max)</label>
                                <input type="text" formControlName="max_seam_length">
                                <small class="mt-2"><img src="assets/svg/Icon feather-info.svg" alt=""> If Robot welding</small>
                            </div>
                            <div class="dropdown ">
                                <label>Unit</label>
                                <select class="select arrow-img" id="max_seam_length_unit" formControlName="max_seam_length_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- ***************************straightening-Machine************************ -->
                    <div *ngIf="selectedMachine.display_name =='straightening machine'" class="">
                        <div class="row mt-3 ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">Sheet Width(Max)</label>
                                <input type="text" formControlName="max_sheet_width">
                            </div>
                            <div class="dropdown ">
                                <label>Unit</label>
                                <select class="select arrow-img" id="max_sheet_width_unit" formControlName="max_sheet_width_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-3 ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">Sheet Thickness(Max)</label>
                                <input type="text" formControlName="sheet_thickness">

                            </div>
                            <div class="dropdown ">
                                <label>Unit</label>
                                <select class="select arrow-img" id="sheet_thickness_unit" formControlName="sheet_thickness_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-3 ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">No of Rolls</label>
                                <input type="text" formControlName="no_of_rolls">
                            </div>
                        </div>
                    </div>
                    <!-- *********************************De-Burring***************************** -->
                    <div *ngIf="selectedMachine.display_name =='de-burring machine' || selectedMachine.display_name =='De-burring machine'" class="container-fluid mr-0 ml-0 pl-0">
                        <div class="row mt-2 ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">Sheet Width (Max)</label>
                                <input type="text" formControlName="max_sheet_width">

                            </div>
                            <div class="dropdown ">
                                <label>Unit</label>
                                <select class="select arrow-img" id="max_sheet_width_unit" formControlName="max_sheet_width_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-3 ml-0 mr-0 pl-0">
                            <div class="col-md-5 pl-0">
                                <label for="">Sheet Thickness (Max)</label>
                                <input type="text" formControlName="sheet_thickness">
                            </div>
                            <div class="dropdown ">
                                <label>Unit</label>
                                <select class="select arrow-img" id="sheet_thickness_unit" formControlName="sheet_thickness_unit">
                                    <option value="mm">mm</option>
                                    <option value="inch">inch</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- ******************************other-machines************************* -->
                    <div *ngIf=" !['Lasercutting', 'Punching', 'Combi Machines', 'Bending', 'Panel Bending', 'Welding', 'Straightening machine', 'De-burring machine','straightening machine','de-burring machine','panel bending','lasercutting'].includes(selectedMachine.display_name)"
                        class="container-fluid mr-0 ml-0 pl-0 pr-0">
                        <div>
                            <div formArrayName="vom_specifications">
                                <div class="mr-0 mt-3 ml-0 row pl-0" *ngFor="let item of machineForm.get('vom_specifications')['controls']; let i = index" [formGroupName]="i">
                                    <div class="col-md-4 pl-0">
                                        <label for=""><span style="color: #ff0000;">*</span> Specifications</label>
                                        <span class="form-error-text onboarding-span" *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('master_specification_name').errors?.required">*Specification is required</span>
                                        <ng-autocomplete [data]="masterSpecs" [searchKeyword]="keywordSpecs" [itemTemplate]="itemTemplate" formControlName="master_specification_name">
                                        </ng-autocomplete>
                                        <ng-template #itemTemplate let-item>
                                            <a [innerHTML]="item.name"></a>
                                        </ng-template>
                                    </div>
                                    <div class="col-md-4">
                                        <label for=""><span style="color: #ff0000;">*</span> Size / capacity</label>
                                        <span class="form-error-text onboarding-span" *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('machine_capacity').errors?.required">*Required</span>
                                        <input type="text" formControlName="machine_capacity">
                                    </div>
                                    <div class="col-md-2 pr-0">
                                        <label><span style="color: #ff0000;">*</span> Unit</label>
                                        <span class="form-error-text onboarding-span" *ngIf="machineFormSubmitted && machineForm.get('vom_specifications')['controls'][i].get('machine_specification_unit_name').errors?.required">*Required</span>
                                        <ng-autocomplete [data]="machineUnits" class="machine-units" [searchKeyword]="keyword" [itemTemplate]="itemTemplate" formControlName="machine_specification_unit_name">
                                        </ng-autocomplete>
                                        <ng-template #itemTemplate let-item>
                                            <a [innerHTML]="item.name"></a>
                                        </ng-template>
                                        <!-- <select class="select arrow-img" n id="machine_specification_unit_name" formControlName="machine_specification_unit_name">
                                            <option value="mm">mm</option>
                                            <option value="inch">inch</option>
                                        </select> -->
                                    </div>
                                    <div class="col-md-2 pr-0 mt-4 mb-0">
                                        <p class="orange-text mt-3 pointer text-right mb-0" (click)="removeMachineSpec(i)">Delete</p>
                                    </div>
                                </div>

                            </div>
                            <div class="mt-4 text-right">
                                <a *ngIf=" !['Lasercutting', 'Punching', 'Combi Machines', 'Bending', 'Panel Bending', 'Welding', 'Straightening machine', 'De-burring machine','straightening machine','de-burring machine','panel bending','lasercutting'].includes(selectedMachine.display_name)"
                                    (click)="addMachineSpec()" class="orange-text container-fluid pointer">Add Specification</a>
                            </div>
                        </div>

                    </div>
                    <br>
                    <hr>
                    <br>
                    <div class="container-fluid mr-0 ml-0 pl-0">
                        <h6>Please Specify</h6>
                        <textarea formControlName="machine_speciality"></textarea>
                    </div>
                    <br>
                    <h6 class="range">Geographical location details</h6>
                    <h6 class="mt-3"><span style="color: #ff0000;">*</span> Factory location of this manufacturing machine ? </h6>
                    <div class="dropdown pl-0 col-md-6">
                        <span class="text-right text-red" *ngIf="machineFormSubmitted && mf.address_id.errors && mf.address_id.errors.required">*Required</span>
                        <select formControlName="address_id" class="select arrow-img factory-address">
                            <option value="">Select </option>
                            <option *ngFor="let address of availableAddresses" [value]="address.id">{{address.address}}</option>
                          </select>
                    </div>
                    <div class="mt-4">
                        <h6>Upload Machine/Factory images</h6>
                        <div class="row container-fluid ">
                            <div class="factory-image pointer col-md-4">
                                <img class="pointer ml-3  text-center" src="assets/svg/Upload.svg" alt="">
                                <br>
                                <span style="margin: 3px auto;" class="text-center pointer p-2">Browse files to upload images (Max file size 10mb)</span>
                                <input style="width: 100%; height: 30px; font-size: 12px; margin: 15px auto;" type="file" accept=".png, .jepg" multiple (change)="uploadFactoryImage($event)">
                            </div>
                            <div class="col-md-6">
                                <div *ngIf="imagesArray.length > 0">
                                    <div *ngFor="let item of imagesArray ; let i = index">
                                        <p class="file-name pointer" (click)="downloadImage(i)">{{i+1}}.&nbsp;&nbsp;{{item.name}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 pointer" (change)="machineOnRent($event)">
                        <div class="row">
                            <mat-checkbox color="warn" (change)="machineOnRent($event)" formControlName="is_available_for_rent"></mat-checkbox>
                            <p class=" mt-1 ml-2 checkbox-text" (click)="machineOnRent($event)">Available for rent</p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>